let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("brD82")).then(() => parcelRequire('i5mLV'));